import { render, staticRenderFns } from "./not-found.page.vue?vue&type=template&id=86ab5f62&"
import script from "./not-found.page.vue?vue&type=script&lang=js&"
export * from "./not-found.page.vue?vue&type=script&lang=js&"
import style0 from "./not-found.page.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports